export default __webpack_public_path__ + "19c6ed4cc0c9f897bc4cbb34fb3af429.ttf";